const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const PATH = new RegExp(`^/pets/view/(${UUID})(?:/runs/(${UUID})|/(brief))?$`, 'i');
/**
 * Inert references only. No decoding, external origin, query, action name or native command is accepted. `/runs/<id>`
 * opens the activity tab on that run; `/brief` opens the Daily Brief tab (gyro_pet_run_brief's link); bare opens activity.
 */
export function petChatNavigation(raw) {
    if (/[\u0000- \u007f]/.test(raw))
        return null;
    const match = PATH.exec(raw);
    if (!match)
        return null;
    return { view: 'pet', petId: match[1].toLowerCase(), tab: match[3] ? 'brief' : 'activity', ...(match[2] ? { runId: match[2].toLowerCase() } : {}) };
}
//# sourceMappingURL=chatNavigation.js.map